<script lang="ts">
  import { onDestroy, onMount } from "svelte";

  import Image from "../Image.svelte";
  export let data;
  export const postKey: string = "";
  let container: HTMLDivElement;
  let containerHeight: number;
  let scale: number | undefined = 100;

  onMount(() => {
    screen.orientation.addEventListener("change", handleOrientationChange);
    const resizeObserver = new ResizeObserver((observed) => {
      requestAnimationFrame(() => {
        const element = observed[0];

        if (element?.contentBoxSize[0]) {
          containerHeight = element.contentBoxSize[0].blockSize;
        }
      });
    });

    resizeObserver.observe(container);

    return () => resizeObserver.unobserve(container);
  });

  function handleOrientationChange() {
    scale = 100;
  }

  onDestroy(() => {
    screen.orientation.removeEventListener("change", handleOrientationChange);
  });

  const setScale = (height: number) => {
    if (height && height > 400) {
      if (window.screen.orientation.type.startsWith("landscape")) {
        return 30;
      }

      return 70;
    }
  };

  $: scale = setScale(containerHeight);
</script>

<style lang="scss">
  .meme-wrapper {
    @media (width >= 600px), (orientation: landscape) {
      justify-content: center;
    }
  }

  .background {
    position: absolute;
    inset: 0 0 120px;
    z-index: -1;
    mask-image: url("./assets/Meme.svg");
    mask-position: center;
    background-color: hsl(var(--color-N100, var(--color-N77)));
    mask-repeat: no-repeat;
    mask-size: cover;
  }

  .meme {
    max-width: 100%;
    height: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    color: hsl(var(--color-N100, var(--color-N77)));
  }

  .video-meme {
    width: 100%;
    aspect-ratio: 1;

    @media (width >= 600px), (orientation: landscape) {
      flex-basis: 40%;
    }
  }
</style>

<div class="meme-wrapper flex w-full items-center justify-center" id={data?.key}>
  <div class="background" />
  <div class="flex items-center justify-center">
    {#if data?.video}
      <video class="video-meme" loop controls muted playsinline autoplay>
        <source src={data.video} type="video/webm" />
      </video>
    {:else}
      <div class="meme" style="flex-basis: {scale}%;" bind:this={container}>
        <Image src={data.image} alt={data.title} />
      </div>
    {/if}
  </div>
</div>
